<template>
  <div class="alert-banner" v-if="alarm">
    <i class="el-icon-warning-outline icon"></i>
    <span class="text">
      <b>电子围栏越界告警</b>
      设备 {{ alarm.deviceName }}
      已越界 <em>{{ durationText }}</em>，实时越界距离 {{ currentDistanceText }}
    </span>
    <span class="more" v-if="count > 1">另有 {{ count - 1 }} 条告警中</span>
    <router-link class="go" :to="'/boundary-alarm-detail/' + alarm.alarmId">
      查看告警详情 <i class="el-icon-arrow-right"></i>
    </router-link>
    <span class="close" @click="dismiss"><i class="el-icon-close"></i></span>
  </div>
</template>

<script>
import { round } from 'lodash'

const DISMISS_KEY = 'ykxt_alarm_banner_dismiss_id'

export default {
  name: 'AlertBanner',

  data() {
    return {
      dismissedId: '',
    }
  },

  computed: {
    activeAlarm() {
      return this.$store.state.boundaryAlarm.activeAlarm
    },

    count() {
      return this.$store.state.boundaryAlarm.activeCount
    },

    alarm() {
      const a = this.activeAlarm
      if (!a || a.alarmId === this.dismissedId) return null
      return a
    },

    // 直接用全局 WS 下发的 durationSeconds，不再前端自算，避免和后端口径不一致
    durationText() {
      const sec = this.alarm && this.alarm.durationSeconds
      if (typeof sec !== 'number' || isNaN(sec)) return '—'
      const m = Math.floor(sec / 60)
      const s = Math.floor(sec % 60)
      return m > 0 ? m + ' 分 ' + s + ' 秒' : s + ' 秒'
    },

    // 越界距离统一米/千米展示：不超过 1000m 用 m，超过则换算成 km；最多保留 2 位小数，末尾的 0 不显示
    currentDistanceText() {
      const v = this.alarm && this.alarm.currentDistance
      if (typeof v !== 'number' || isNaN(v)) return '—'
      if (v >= 1000) return round(v / 1000, 2) + ' km'
      return round(v, 2) + ' m'
    },
  },

  created() {
    try {
      this.dismissedId = sessionStorage.getItem(DISMISS_KEY) || ''
    } catch (e) {}
  },

  methods: {
    dismiss() {
      this.dismissedId = this.activeAlarm ? this.activeAlarm.alarmId : ''
      try {
        sessionStorage.setItem(DISMISS_KEY, this.dismissedId)
      } catch (e) {}
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 16px;
  background: #fef0f0;
  border-bottom: 1px solid #fbc4c4;
  color: #f56c6c;
  font-size: 14px;
  line-height: 18px;

  .icon {
    display: inline-flex;
    align-items: center;
    font-size: 16px;
    line-height: 18px;
    flex-shrink: 0;
  }

  .text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 18px;
    color: #606266;

    b {
      color: #f56c6c;
    }

    em {
      color: #f56c6c;
      font-style: normal;
      font-weight: 600;
    }
  }

  .more {
    flex-shrink: 0;
    line-height: 18px;
    color: #909399;
  }

  .go {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    line-height: 18px;
    color: #f56c6c;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .close {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
    line-height: 18px;
    color: #909399;
    padding: 4px;

    &:hover {
      color: #606266;
    }
  }
}
</style>
